/** The campaign a visitor came from, as the site's links name it (utm_source, utm_medium, utm_campaign): kept in this
 * browser from the first page until the sign-up sends it, codes only, which the database keeps when they read as such. */
import { textOf } from "../../search";

const key = "instarchi.acquisition";

const fields = ["source", "medium", "campaign"] as const;

type Acquisition = Partial<Record<(typeof fields)[number], string>>;

/** Keeps the campaign of the page the visitor opened, if it names one. */
export function rememberAcquisition(search: string) {
  const params = new URLSearchParams(search);
  const read: Acquisition = {};
  for (const name of fields) {
    const value = params.get(`utm_${name}`);
    if (value !== null && value !== "") {
      read[name] = value.slice(0, 64);
    }
  }
  if (Object.keys(read).length === 0) {
    return;
  }
  try {
    localStorage.setItem(key, JSON.stringify(read));
  } catch {
    // A browser that keeps nothing loses the campaign, never the sign-up.
  }
}

/** The campaign to send with the sign-up, then forgotten. */
export function takeAcquisition(): Acquisition | undefined {
  try {
    const kept = localStorage.getItem(key);
    localStorage.removeItem(key);
    return kept === null ? undefined : acquisitionOf(JSON.parse(kept));
  } catch {
    return undefined;
  }
}

/** The campaign kept, read back field by field: what is not a text is dropped. */
function acquisitionOf(kept: unknown): Acquisition {
  const read: Acquisition = {};
  if (typeof kept !== "object" || kept === null) {
    return read;
  }
  for (const name of fields) {
    const value = textOf(Reflect.get(kept, name));
    if (value !== undefined) {
      read[name] = value;
    }
  }
  return read;
}
